/* ------------------------------------------------------------------------------
@name: Experience Detail
@description: Experience Detail
--------------------------------------------------------------------------------- */

const ExperienceDetail = (() => {
  // - handleClickLearnMore
  const handleClickLearnMore = () => {
    $('.experience__card__button').on('click', (e) => {
      $('.experience-detail__bottom').addClass('is-visible');
      $(e.currentTarget).hide();
    });
  };

  const init = () => {
    handleClickLearnMore();
  };

  return {
    init
  };
})();

export default ExperienceDetail;
